import React, { useEffect, useMemo, useState } from 'react';
import HeroSection from '../components/HeroSection';
import Services from '../components/Services';
import About from '../components/About';
import Testimonials from '../components/Testimonials';
import CtaBand from '../components/CtaBand';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import NewsletterSignup from '../components/NewsletterSignup';
import SEO from '../components/SEO';
import { getPageContent } from '../services/pageContentService';
import './HomePage.css';

const HomePage = () => {
  const [remoteSections, setRemoteSections] = useState(null);

  const defaultSections = useMemo(() => ([
    { key: 'hero', enabled: true },
    { key: 'services', enabled: true },
    { key: 'about', enabled: true },
    { key: 'testimonials', enabled: true },
    { key: 'cta', enabled: true },
    { key: 'faq', enabled: true },
    { key: 'contact', enabled: true },
    { key: 'newsletter', enabled: true },
  ]), []);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const data = await getPageContent('home', 'sections');
        const items = data?.items;
        if (!isMounted) return;
        if (Array.isArray(items) && items.length > 0) {
          const normalized = items
            .map((x) => ({
              key: x?.key || '',
              enabled: x?.enabled !== false,
            }))
            .filter((x) => x.key);
          setRemoteSections(normalized.length ? normalized : []);
        } else {
          setRemoteSections([]);
        }
      } catch (e) {
        if (isMounted) setRemoteSections([]);
      }
    })();
    return () => { isMounted = false; };
  }, []);

  const sections = (remoteSections && remoteSections.length > 0) ? remoteSections : defaultSections;

  const sectionMap = {
    hero: (
      <section id="hero" className="home-section home-section--hero">
        <HeroSection />
      </section>
    ),
    services: (
      <section id="services" className="home-section section-alt">
        <Services />
      </section>
    ),
    about: (
      <section id="about" className="home-section section-white">
        <About />
      </section>
    ),
    testimonials: (
      <section id="testimonials" className="home-section home-section--testimonials">
        <Testimonials />
      </section>
    ),
    cta: (
      <section id="cta" className="home-section home-section--cta">
        <CtaBand />
      </section>
    ),
    faq: (
      <section id="faq" className="home-section section-muted">
        <FAQ />
      </section>
    ),
    contact: (
      <section id="contact" className="home-section section-white">
        <Contact />
      </section>
    ),
    newsletter: (
      <section id="newsletter" className="home-section section-alt home-section--newsletter">
        <div className="container home-newsletter-wrap">
          <NewsletterSignup />
        </div>
      </section>
    ),
  };

  return (
    <div className="home-page">
      <SEO
        title="Dr. Muyabin - Expert Dental Care in Dar es Salaam, Tanzania"
        description="Expert dental care in Dar es Salaam, Tanzania. 5 years of experience, currently pursuing Masters in Orthodontics. Registered with MCT. Book your appointment today!"
        keywords="dentist Tanzania, dental care Dar es Salaam, orthodontics, Dr. Muyabin, dental clinic Tanzania, teeth cleaning, cosmetic dentistry, dental implants"
      />
      {sections
        .filter((s) => s.enabled)
        .map((s, idx) => (
          <React.Fragment key={`${s.key}_${idx}`}>
            {sectionMap[s.key] || null}
          </React.Fragment>
        ))}
    </div>
  );
};

export default HomePage;
